import { render } from "./LazyComponent.vue?vue&type=template&id=4cc51184&ts=true"
import script from "./LazyComponent.vue?vue&type=script&lang=ts"
export * from "./LazyComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__